import { api, ok } from "./api.js";
import { APIUrl } from "./config.js";

// Dokumente, die die Therapeutin fuer den Patienten freigegeben hat.
// Der Download laeuft ueber einen kurzlebigen, signierten Link, weil ein
// <a href> bzw. der WebView keinen Bearer-Header mitschickt.

/** Anzahl freigegebener Dateien (Dashboard-Kachel). */
export function documentCount() {
    return api
        .get("/frontend/document/count")
        .then((res) => (ok(res.data) ? res.data.data.totalFiles : 0))
        .catch(() => 0);
}

/** Download-Link holen und die Datei oeffnen (PDF/Bilder inline, Rest als Download). */
export function openDocument(documentId) {
    return api.get("/frontend/document/file/link", { params: { documentId } }).then((res) => {
        if (!ok(res.data)) throw new Error("no link");
        const { path, url, mimeType } = res.data.data;
        // Immer ueber die eigene API-Basis gehen - so landet der Link auf
        // demselben Host (und Port), den die App fuer alle Aufrufe nutzt.
        const base = path ? APIUrl.replace(/\/$/, "") + path : url;
        const inline = /^(application\/pdf|image\/|video\/|audio\/)/.test(mimeType || "");

        // In der App-Huelle (Appify, UA enthaelt "median"): die WebView faengt die
        // Navigation ueber ihr Link-Routing ab und uebergibt die URL dem nativen
        // Download-Handler (Vorschau / Teilen). Ein target=_blank wuerde dort
        // ein neues Fenster verlangen und nicht ausgeliefert.
        if (isAppShell()) {
            window.location.href = base;
            return base;
        }

        const href = inline ? base + "&inline=1" : base;

        // Im Browser: neuer Tab, PDF/Bild inline
        const a = document.createElement("a");
        a.href = href;
        a.target = "_blank";
        a.rel = "noopener";
        a.className = "external";
        document.body.appendChild(a);
        a.click();
        a.remove();
        return href;
    });
}

function isAppShell() {
    return /median|appify/i.test(navigator.userAgent || "");
}
